import { Navigate } from "react-router-dom";
import secureStorage from "../../helpers/locStore";
import { useEffect } from "react";
import { isSessionValid, logoutUser } from "../../helpers/auth";

const ProtectedRoute = ({ children }) => {
  if (!isSessionValid()) {
    logoutUser();
  }
  useEffect(() => {
    const expiry = secureStorage.getItem("expiry");
    if (expiry) {
      const timeout = new Date(expiry).getTime() - new Date().getTime();
      const timer = setTimeout(() => {
        logoutUser();
      }, timeout);

      return () => clearTimeout(timer);
    }
  }, []);

  const user = secureStorage.getItem("userdata");

  return user ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
